import api from './client';

/** Typed GET — resolves to the response body. For non-2xx or custom validateStatus, use `api` directly. */
export async function get<Response>(
  path: string,
  parameters?: Record<string, unknown>
): Promise<Response> {
  const {data} = await api.get<Response>(path, {params: parameters});
  return data;
}

/** Typed POST — resolves to the response body. */
export async function post<Request, Response = void>(
  path: string,
  body?: Request,
  parameters?: Record<string, unknown>
): Promise<Response> {
  const {data} = await api.post<Response>(path, body, {params: parameters});
  return data;
}

/** Typed PATCH — resolves to the response body. */
export async function patch<Request, Response = void>(
  path: string,
  body?: Request
): Promise<Response> {
  const {data} = await api.patch<Response>(path, body);
  return data;
}

/** Typed PUT — resolves to the response body. */
export async function put<Request, Response = void>(
  path: string,
  body?: Request
): Promise<Response> {
  const {data} = await api.put<Response>(path, body);
  return data;
}

/** Typed DELETE — resolves to the response body (usually void for 204). */
export async function del<Response = void, Request = never>(
  path: string,
  body?: Request
): Promise<Response> {
  const {data} =
    body === undefined
      ? await api.delete<Response>(path)
      : await api.delete<Response>(path, {data: body});
  return data;
}
